import { EnvMicroHr } from "lib-klab-core";

export const envHrLocal: EnvMicroHr = {
  host: "",
  apiBasePath: "/ms-hr",
  useMocks: false,
};

export const envHrDev: EnvMicroHr = {
  host: "https://gatewayapi-dev.erp.inclub.world",
  apiBasePath: "/ms-hr",
  useMocks: false,
};

export const envHrProd: EnvMicroHr = {
  host: "https://gatewayapi.erp.inclub.world",
  apiBasePath: "/ms-hr",
  useMocks: false,
};
